import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	paper: {
		padding: theme.spacing.unit + 4,
		margin: "12px 11px 12px 0",
		width: "32%"
	},
	checkbox: {
		padding: theme.spacing.unit / 4
	},
	favourite: {
		padding: theme.spacing.unit / 4
	},
	favouriteIcon: {
		fontSize: theme.spacing.unit * 3
	},
	textEllipsis: {
		width: '100%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		paddingRight: theme.spacing.unit
	},
	title: {
		lineHeight: theme.spacing.unit * 4 + "px",
	},
	concept: {
		opacity: 0.8,
		lineHeight: theme.spacing.unit * 4 + "px",
	},
	contentTypeIcon: {
		display: 'inline-block',
		verticalAlign: 'top',
		marginRight: theme.spacing.unit + 4
	},
	subTitle: {
		// display: 'inline-block',
		// lineHeight: theme.spacing.unit * 4 + "px",
		fontSize:"13px",
		textOverflow: 'ellipsis',
		overflow:"hidden",
		whiteSpace:"nowrap"
	},
	contentType: {
		fontSize: theme.spacing.unit + 4,
		padding: '5px 10px',
		backgroundColor: "#FF830F"
	},
	contentProgress: {
		display: 'inline-block',
		width: '75px',
		height: '12px',
		borderRadius: '5px',
		background: theme.palette.background.default,
		marginRight: '2px',
		'& span': {
			background: '#EB4F4F',
			borderRadius: '5px',
			display: 'block',
			height: '100%'
		}
	},
	statusButton: {
		color: '#fff',
		padding: '3px 8px',
		display: 'inline-block',
		fontSize: '13px',
		borderRadius: '14px',
		marginRight: '3px',
	},
	publishButton: {
		background: '#3399F7',
	},
	inReviewButton: {
		background: '#B3B4B3',
	},
	liveButton: {
		background: '#8ECE30',
	},
	plannedButton: {
		background: '#FF830F',
	},
	previewButton: {
		background: theme.palette.common.white,
		border: '1px solid #DDDDDD',
		boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.0519701)',
		padding: theme.spacing.unit,
		paddingTop: 2,
		opacity: 0.7,
		'& svg': {
			marginRight: theme.spacing.unit
		}
	},
	previewButtonNew:{
		border: 'solid 1px #1D4875',
		borderRadius: '25px',
		lineHeight: '10px',
		padding: '6px 10px',
		color: '#1D4875',
		'font-weight': '500',
		'opacity': 'inherit',
		fontSize: '12px',
		height: 'auto',
		background: '#fff',
		'box-shadow': 'inherit',
	},
	likesViews:{
		fontSize:"10px",
		color:"#666666",
		paddingTop:"5px",
	},
	padtopNew:{
		padding:'10px 0',
	},
	statusText: {
		fontSize: '13px',
		textTransform: 'capitalize',
	},
	viewDetails: {
		opacity: 0.7,
		fontSize: '14px',
		paddingLeft: '12px',
		color: theme.palette.text.secondary
	},
	fixedLabelSide: {
		zIndex: 9999,
		position: "absolute",
		top: "0",
		right: "0",
		backgroundColor: "red",
		padding: "9px",
		color: "#ffffff",
		fontWeight: 600
	},
	browseAll:
	{
		fontSize:"14px"	,
		marginLeft:"160px",
		color:"#666666",
		fontStyle: "normal",
		fontWeight: 500

	}
});